import { Footer } from 'rsuite';
import { jsx as _jsx } from "react/jsx-runtime";
export default (() => { return /*#__PURE__*/ _jsx(Footer, {}); });
